export default (props, vars) => props?.['id'] || props?.['register']?.['name'];
